import { AddRounded, CheckCircleOutlineRounded, CloseRounded, Error, ErrorRounded, QrCodeScannerRounded } from '@mui/icons-material';
import { Alert, Box, Button, Grid, IconButton, Paper, Typography } from '@mui/material';
import axios from 'axios';
import _, { isEmpty, size } from 'lodash';
import React, { Component } from 'react';
import Creatable from '../../common/Creatable';
import Currency from '../../common/Currency';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';

class EquipementPartPopUpSpendingDemand extends Component {
    state = { 
        equipement_id: "",
        // equipement_amount: this.props.spending_amount || "",
        list: size(this.props.list) > 0 ? this.props.list : [
            { equipement_id: "", equipement_idDisplay: {}, equipement_amount : "", error: ""}
        ],
        nb: size(this.props.list) > 0 ? size(this.props.list) :  1
    }
    componentDidMount = () => {
        // const {list} = this.props;
        window.scrollTo(0, 0);
        if(isEmpty(this.props.EQUIPEMENTS) ){
            this.props.fetchEquipements()
        }
        if(isEmpty(this.props.VEHICULES) ){
            this.props.fetchVehicules()
        }
        
        // if(!isEmpty(this.props.list)) {
        //     list.map((item, i) => {
        //         list[i].equipement_idDisplay = { value: list[i].equipement_id, label: `${list[i].equipement_ref.toUpperCase()} | ${list[i].equipement_name}` }
        //     })
        // }
    }
    handleAddLine = () => {
        let list = [].concat(this.state.list)
        list.push({ equipement_id: "", equipement_idDisplay: {}, equipement_amount : "", error: ""})
        this.setState({
            nb: this.state.nb + 1,
            list
        })
    }
    handleDeleteLine = (index) => {
        let list = [].concat(this.state.list)

        list = [
            ...list.slice(0,index),
            ...list.slice(index +1),
        ]
        
        this.setState({
            list: list,
            nb: this.state.nb - 1,
            
        })   
    }
    handleChange = (e, index) => {
        let list = [].concat(this.state.list)
        const { value, name } = e.target;
        
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "equipement_amount" ]
        
        if (!floatFields.includes(name) ){
            list[index][name] = value
            // list[index].boxAssoId = Object.keys(equipList)[index]
            
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            list[index][name] = parseFloat(value)
            // list[index].boxAssoId = Object.keys(equipList)[index]
        }

        this.setState({
            list
        })
    }
    handleChangeSelect = (option, index, name) => {
        let list = [].concat(this.state.list)
        
        if(option){
            list[index][name] = option.value || ""
            list[index][`${name}Display`] = option
        } else {
            list[index][name] =  ""
            list[index][`${name}Display`] = {}
        }
        this.setState({
            list
        })
    }
    validate =  async() => {
        const { list } = this.state;
        let cpList = [].concat(list)
        let equipList = []
        let noError = true
        cpList.forEach( item => {
            equipList.push(item.equipement_id)
        })

        list.forEach( (item, idx) => {                      

            if(!item.equipement_amount){
                cpList[idx].error2 = "Montant Invalide"
                noError = false
            } else{
                cpList[idx].error2 = ""
            }
        })

        if( (this.props.spending_amount - _.sumBy(this.state.list, 'equipement_amount')) < 0 ) {
            noError = false
            this.props.notif("error", "Montant insuffisant")
        }
        this.setState({ list: cpList})
        return noError
    }
        
    handleSubmit = async() => {
        // console.log(this.state.equipement_id);
        let idList = []

        if (await this.validate() ){
            // get Infos (name and boxAssoId)
            this.state.list.forEach( item => {
                idList.push(item.equipement_id)                
            })
           
            console.log('====================================');
            console.log({idList});
            console.log('====================================');
            this.props.setEquipement( idList, this.state.list)
            // this.props.handleClose
        }
    }
    render() {
        console.log('====================================');
        console.log(this.state);
        console.log(_.sumBy(this.state.list, 'equipement_amount') );
        console.log('====================================');
        const { EQUIPEMENTS, VEHICULES } = this.props;
        let ALL = Object.values(EQUIPEMENTS).concat(Object.values(VEHICULES))
        return (
            <Dialog
                title="Ajouter Equipement(s)"
                open={true}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
            >
                <Alert severity="warning">
                    Total: <Currency value={this.props.spending_amount} /> - Restant <Currency value={ this.props.spending_amount - (_.sumBy(this.state.list, 'equipement_amount')) } />
                </Alert>
                {this.state.list.map( (line, index) => 
                    <Box p={1}>
                        <Paper style={{position: "relative"}}>
                            {!isEmpty(ALL) ? 
                                <Grid container>
                                    <Grid item xs={12} sm={8}>
                                        {size(this.state.list) > 1 &&
                                            <IconButton 
                                                color="error" 
                                                onClick={() => this.handleDeleteLine(index)} 
                                                style={{position: "absolute", left: "-35px", top: "15px"}} 
                                            >
                                                <CloseRounded />
                                            </IconButton>
                                        }
                                            <Box style={{display:"flex"}}>
                                                <Creatable
                                                    label="Equipement"
                                                    value={this.state.list[index].equipement_idDisplay}
                                                    name="equipement_id"
                                                    onChange={ (option) => this.handleChangeSelect(option, index, "equipement_id")}
                                                    error={this.state.list[index].error}
                                                    labelWidth={100} 
                                                    options={Object.values(ALL).map( item => ({
                                                        label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                                        value: item.equipement_id,
                                                    }))}
                                                    // error={this.props.errors.spending_equipement}
                                                    // value={this.props.spending_equipementDisplay}
                                                    // onChange={(option) => this.props.handleChangeSelect(option, "spending_equipement")}
                                                />
                                                {/* <IconButton onClick={() => this.openScanner("equipement")} color="primary">
                                                    <QrCodeScannerRounded />
                                                </IconButton> */}

                                            </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputText
                                            required
                                            label="Part"
                                            type="number"
                                            name="equipement_amount"
                                            value={this.state.list[index].equipement_amount}
                                            onChange={ (e) => this.handleChange(e, index)} // add regex validation
                                            error={this.state.list[index].error2}
                                        />
                                    </Grid>
                                    
                                </Grid>
                            :
                                <Alert severity="warning">Aucun équipement disponible</Alert>
                            }
                        </Paper>
                    </Box>
                )}
                <Box p={1} style={{textAlign: 'center'}}>
                    <Button onClick={this.handleAddLine} startIcon={<AddRounded />}>Equipement</Button>
                </Box>
            </Dialog>
        );
    }
}

export default EquipementPartPopUpSpendingDemand;